import * as Forms       from '../../components/forms';
import React            from 'react';
import rollbar          from '../../rollbar';
import StandaloneButton from '../../components/standalone_button';


export default function Credentials({ authenticate, onForgotPasswordClick }) {

  async function save({ username, password }) {
    try {
      await authenticate({ username, password });
    } catch (error) {
      switch (error.statusCode) {
        case 400:
          throw new Error('Please fill email and password fields, they are required!');
        case 401:
          throw new Error('Incorrect email & password combination. Please try again!');
        case 429:
          throw new Error('Did you forget your password? Click on “forgot my password” to get a new password.');
        default: {
          rollbar.error(error);
          throw new Error('Oops. Something went wrong. Please try again.');
        }
      }
    }
  }

  return (
    <React.Fragment>
      <div className="block">
        <Forms.Form save={save}>
          <Fields/>
        </Forms.Form>
        <StandaloneButton label="Forgot your password?" onClick={onForgotPasswordClick}/>
      </div>
    </React.Fragment>
  );
}


function Fields(form) {
  return (
    <div className="list">
      <ul>
        <Forms.Error  {...form}/>
        <Forms.Input  {...form} label="Email" name="username" type="email" autoFocus={true} required/>
        <Forms.Input  {...form} label="Password" name="password" type="password" required/>
        <Forms.Button {...form} label="Sign In"/>
      </ul>
    </div>
  );
}
